import { LngLat, LngLatBounds } from 'mapbox-gl';
import { RouteDtoModelType } from '../../store/mst/models';

const getBoundsFromRoutes = (routes: RouteDtoModelType[]): LngLatBounds | null => {
  const allRoutesWithPolyLines = routes.filter((route) => !!route.polylineArray?.length);
  const bounds = new LngLatBounds();

  allRoutesWithPolyLines.forEach((route) => {
    route.polylineArray?.forEach((lngLat: [number, number]) => {
      const [lng, lat] = lngLat;

      if (lat != null && lng != null) {
        bounds.extend(new LngLat(lng, lat));
      }
    });
  });

  return bounds.isEmpty() ? null : bounds;
};

export default getBoundsFromRoutes;
